function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M47.46 39.33a4 4 0 01-3.46 6H4a4 4 0 01-3.46-6l20-34.66a4 4 0 016.93 0l19.99 34.66zM24 32.17a3.83 3.83 0 100 7.66 3.83 3.83 0 000-7.66zm-3.64-13.78l.62 11.33a1 1 0 001 .95h4.04a1 1 0 001-.95l.62-11.33a1 1 0 00-1-1.06h-5.28a1 1 0 00-1 1.06z"
})));